<script>
    import ListPanel from "./ListPanel.svelte";
    import Padding from "./Padding.svelte";
    import Title from "./Title.svelte";

    export let content;

    // https://stackoverflow.com/a/4312956
    function monthDiff(dateFrom, dateTo) {
        return (
            dateTo.getMonth() -
            dateFrom.getMonth() +
            12 * (dateTo.getFullYear() - dateFrom.getFullYear()) +
            1
        );
    }

    let contentActivites = content.activities.map((activity) => {
        let endDateIsNow = false;
        if (!activity.main) activity.main = {};
        if (!activity.footer) activity.footer = {};
        let startDate;
        let endDate;
        if (activity.data) {
            if (activity.data.startDate)
                startDate = new Date(activity.data.startDate);

            if (activity.data.endDate) {
                endDateIsNow = activity.data.endDate == "present";
                endDate = endDateIsNow
                    ? new Date()
                    : new Date(activity.data.endDate);
            }
        }

        if (startDate && endDate) {
            if (!activity.subtitle) {
                let diff = monthDiff(startDate, endDate);
                let years = Math.floor(diff / 12);
                let months = Math.floor(diff - years * 12);

                activity.subtitle = "";
                if (years > 0) {
                    activity.subtitle = `${years} year`;
                    if (years > 1) activity.subtitle += "s";
                }

                if (months > 0) {
                    if (activity.subtitle)
                        activity.subtitle = `${activity.subtitle} `;

                    activity.subtitle = `${activity.subtitle}${months} month`;
                    if (months > 1) activity.subtitle += "s";
                }
            }
            if (!activity.footer.text && !activity.footer.links) {
                let startDateLocale = startDate.toLocaleDateString("en", {
                    year: "numeric",
                    month: "short",
                });
                let endDateLocale = endDateIsNow
                    ? "present"
                    : endDate.toLocaleDateString("en", {
                          year: "numeric",
                          month: "short",
                      });
                activity.footer.text = `${startDateLocale} - ${endDateLocale}`;
            }
        }

        return activity;
    });
</script>

<div>
    <Title title={content.header} />
    <Padding vertical="12" />
    <div class="content-list">
        {#each contentActivites as activity, i}
            <div class="list-panel">
                <ListPanel {activity} />
            </div>
        {/each}
    </div>
</div>

<style>
    .content-list {
        display: flex;
        align-items: center;
        justify-content: space-around;
        flex-wrap: wrap;
    }

    .list-panel {
        margin: 12px;
    }
</style>
